import styled from 'styled-components';



import {Theme} from './../../../../../stories/theme/types';
import {RowStyles, ColumnStyles} from './../../../../../stories/core-components/Layouts/Layouts';



export const SortingWrapDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}

  width:100%;
  background-color:${props.theme.colors.white.base};
  padding-left:${props.theme.spacing.xlarge};
  padding-right:${props.theme.spacing.xlarge};
  border-radius:${props.theme.misc.borderRadius.custom(4)};
  margin-bottom:${props.theme.spacing.base}
  justify-content: space-between
  align-items: center;
`,
);


export const SortByDiv = styled.div(
  props =>
  `
  display: flex;
  justify-content: center;
  align-items: center;
  `
)

export const SortbyDividerDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}
  padding-top:${props.theme.spacing.large};
  padding-bottom:${props.theme.spacing.large};

`,
);

export const SortingFiltersDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  ${RowStyles}



`,
);

export const SortBytxtSpan = styled.span(
  props => `
  font-weight: bold;
  font-size:${props.theme.font.custom(14)};
  font-family:${props.theme.font.fontFamily};

`,
);

export const FilterstxtSpan = styled.span(
  props => `
  font-weight: bold;
  font-size:${props.theme.font.small};
  padding-top:${props.theme.spacing.large};
  padding-bottom:${props.theme.spacing.large};
  padding-left:${props.theme.spacing.large};
  padding-right:${props.theme.spacing.large};
  display: flex;
  align-items: center;
  cursor: pointer;
  &.active{
    color:${props.theme.colors.goBrand.blue}
  }
`,
);

export const LeftWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;

`,
);

export const ShowingTextSpan = styled.span(
  props => `
  font-size:${props.theme.font.custom(14)};
`,
);



export const BusTextSpan = styled.span(
  props => `

  padding-left:${props.theme.spacing.small};
  font-size:${props.theme.font.custom(14)};
  font-weight:bold;
`,
);









